<template>
  <div>
    <template>
      <div class="mb-2">
        <v-btn
          class="mr-2"
          @click="handleAdd()"
        >
          线
        </v-btn>
        <v-btn
          class="mr-2"
          @click="handleAdd('box')"
        >
          框
        </v-btn>
        <v-btn
          class="mr-2"
          @click="handleAdd('image')"
        >
          图片
        </v-btn>
        <v-btn
          class="mr-2"
          @click="handleAdd('rect')"
        >
          块
        </v-btn>
        <v-btn
          class="mr-2"
          @click="handleDelete(selectedShapeName)"
        >
          删除
        </v-btn>
        <a
          class="mr-2"
          href="javascript:location.reload()"
        >Reload</a>
        <a
          class="mr-2"
          href="https://github.com/konvajs/konva"
        >GitHub</a>
        <a
          class="mr-2"
          href="https://konvajs.org/docs/vue/index.html"
        >文档</a>
      </div>
    </template>
    <template>
      <v-stage
        ref="stage"
        :config="stageSize"
        style="border: 1px solid;"
        @mousemove="handleStageMouseMove"
        @mouseout="handleStageMouseOut"
        @mousedown="handleStageMouseDown"
        @touchstart="handleStageMouseDown"
      >
        <v-layer>
          <v-image
            v-for="item in shapeList.filter(item => item.type === 'image')"
            :ref="`${item.name}`"
            :key="item.name"
            :config="item"
          />
          <v-circle
            v-for="item in shapeList.filter(item => item.type === 'circle')"
            :ref="`${item.name}`"
            :key="item.name"
            :config="item"
          />
          <v-rect
            v-for="(item) in shapeList.filter(item => item.type === 'rect')"
            :ref="`${item.name}`"
            :key="item.name"
            :config="item"
            @mousemove="handleMouseMove"
          />
          <v-line
            v-for="item in shapeList.filter(item => item.type === 'line')"
            :ref="`${item.name}`"
            :key="item.name"
            :config="item"
          />
          <v-text
            v-for="item in shapeList.filter(item => item.type === 'text')"
            :ref="`${item.name}`"
            :key="item.name"
            :config="item"
          />
          <v-transformer ref="transformer" />
          <v-rect
            ref="myrect"
            :config="{
              filters: filters,
              noise: 1,
              x: 10,
              y: 10,
              width: 50,
              height: 50,
              fill: color,
              shadowBlur: 10
            }"
            @mousemove="handleMouseMove"
          />
        </v-layer>
      </v-stage>
      <div>
        外面 demo2
      </div>
    </template>
  </div>
</template>

<script>
import Konva from 'konva';

const width = window.innerWidth;
const height = window.innerHeight;

const image = new window.Image();
image.src = require("./cake.jpg");

export default {
  data() {
    return {
      stageSize: {
        width: width,
        height: height - 200
      },
      image: image,
      selectedShapeName:'',
      shapeList: [
        { type: 'rect',name: 'rect', draggable: true, x: 100, y: 100, width: 100, height: 50, stroke: 'black', fill: 'orange', shadowBlur: 10, noise: 1, },
      ],
      color: 'green',
      filters: [Konva.Filters.Noise]
    };
  },

  mounted() {
    const rectNode = this.$refs.myrect.getNode();
    rectNode.cache();
    for (let i = 0; i < this.shapeList.length; i++) {
      const shape = this.shapeList[i];
      shape.fill = this.color;
      shape.filters = this.filters;
      const shapeNode = this.$refs[`${shape.name}`][0].getNode();
      shapeNode.cache();
    }
  },

  methods: {
    writeMessage(message) {
      // 更新mytext
      const shape = this.shapeList.find((item) => item.name === 'mytext');
      if (shape){ shape.text = message;}
    },
    handleStageMouseOut() {
      this.writeMessage('Mouseout Stage');
    },
    handleStageMouseMove() {
      const mousePos = this.$refs.stage.getNode().getPointerPosition();
      const x = mousePos.x;
      const y = mousePos.y;
      this.writeMessage('x: ' + x + ', y: ' + y);
    },
    handleStageMouseDown(e) {
      this.writeMessage('Click Stage');
      // console.log('handleStageMouseDown', e);

      // clicked on stage - clear selection
      if (e.target === e.target.getStage()) {
        this.selectedShapeName = '';
        this.updateTransformer();
        return;
      }

      // clicked on transformer - do nothing
      const clickedOnTransformer =
        e.target.getParent().className === 'Transformer';
      if (clickedOnTransformer) {
        return;
      }

      // find clicked rect by its name
      const name = e.target.name();
      // const rect = this.rectangles.find((r) => r.name === name);
      if (name) {
        this.selectedShapeName = name;
      } else {
        this.selectedShapeName = '';
      }
      this.updateTransformer();
    },
    updateTransformer() {
      // here we need to manually attach or detach Transformer node
      const transformerNode = this.$refs.transformer.getNode();
      const stage = transformerNode.getStage();
      const { selectedShapeName } = this;

      const selectedNode = stage.findOne('.' + selectedShapeName);
      // do nothing if selected node is already attached
      if (selectedNode === transformerNode.node()) {
        return;
      }

      if (selectedNode) {
        // attach to another node
        transformerNode.nodes([selectedNode]);
      } else {
        // remove transformer
        transformerNode.nodes([]);
      }
    },
    handleAdd(type = 'line') {
      if (type === 'line') {
        this.writeMessage('Add line');
        this.shapeList.push({ type: 'line', name: `${new Date().valueOf()}`, draggable: true, x: 0, y: 20, points: [0, 0, 150, 0], stroke: 'black', strokeWidth: 15 });
      }
      if (type === 'box') {
        this.writeMessage('Add Box');
        this.shapeList.push({ type: 'rect', name: `${new Date().valueOf()}`, draggable: true,x: 0, y: 0, width: 100, height: 50, stroke: 'black' });
      }
      if (type === 'rect') {
        this.writeMessage('Add Rect');
        this.shapeList.push({ type: 'rect',name: `${new Date().valueOf()}`, draggable: true, x: 100, y: 100, width: 100, height: 50, stroke: 'black', fill: this.color, shadowBlur: 10, noise: 1, });
      }
      if (type === 'image') {
        this.writeMessage('Add image');
        this.shapeList.push({ type: 'image', name: `${new Date().valueOf()}`, draggable: true, x: 0, y: 0, image: image, scaleX: 1, scaleY: 1,rotation: 0,});
      }
    },
    handleDelete(name) {
      if (name) {
        this.writeMessage('Delete ' + name);
        this.shapeList = this.shapeList.filter((item) => item.name !== name);
        this.selectedShapeName = '';
      }
    },
    handleMouseMove() {
      const color = Konva.Util.getRandomColor();
      
      // recache
      const rectNode = this.$refs.myrect.getNode();
      
      rectNode.setAttrs({
        fill: color,
        filters: [Konva.Filters.Noise],
        noise: 1,
      });
       // may need to redraw layer manually
      rectNode.cache();

      for (let i = 0; i < this.shapeList.length; i++) {
        const shape = this.shapeList[i];
        // if (shape.type === 'rect') {
          shape.fill = color;
          shape.filters = [Konva.Filters.Noise];
          shape.noise = 1;
          const shapeNode = this.$refs[`${shape.name}`][0].getNode();
          shapeNode.cache();
        // }
      }
    },
  }
};
</script>

<style>

</style>